exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mian-center{\r\n  padding-bottom: 70px!important;\n}\r\n", "", {"version":3,"sources":["D:/git/qrt_m/src/pages/home/home.vue"],"names":[],"mappings":";AACA;EACE,+BAA+B;CAChC","file":"home.vue","sourcesContent":["\n.mian-center{\r\n  padding-bottom: 70px!important;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a20fe8b","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/home/home.vue
// module id = SCtS
// module chunks = 3